import { Box } from '@mui/material'
import { CHECKUP_COMMENT_MAX_LENGTH } from 'components/cattles/checkupPage/utils/checkupValidation'
import Input from 'components/shared/textFields/Input'
import { ICheckupList } from 'models'
import { Dispatch, SetStateAction } from 'react'
import { COLORS } from 'styles/colors'

type ExtraInfoSectionProps = {
	comment: string
	setCheckupInfo: Dispatch<SetStateAction<ICheckupList>>
	isError: boolean
}

const ExtraInfoSection = ({
	comment,
	setCheckupInfo,
	isError,
}: ExtraInfoSectionProps) => {
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const newComment = e.target.value.slice(0, CHECKUP_COMMENT_MAX_LENGTH)
		setCheckupInfo(prev => ({
			...prev,
			comment: newComment,
		}))
	}

	return (
		<Box
			width='100%'
			sx={{
				'& .MuiInputLabel-root': {
					color: COLORS.secondary,
				},
			}}
		>
			<Input
				value={comment}
				onChange={handleChange}
				isMultiline={true}
				label='Комментарий'
				width='100%'
				height='100px'
				rows={3}
				maxLength={CHECKUP_COMMENT_MAX_LENGTH}
				isError={isError}
				helperText={
					isError ? 'Обязательное поле, если осмотр проведен без лечения' : ''
				}
				sx={{
					height: 'auto',
					overflow: 'visible',
					'.MuiFormHelperText-root': {
						width: 'max-content',
						whiteSpace: 'nowrap',
					},
				}}
			/>
		</Box>
	)
}

export default ExtraInfoSection
